<template>
  <b-modal
    id="view-video-modal"
    hide-footer
    hide-header
    centered
    dialog-class="!p-0"
    body-class="!p-0"
    @hidden="onModalHidden"
  >
    <video
      ref="videoPlayer"
      :src="videoSrc"
      class="w-full"
      controls
      controlsList="nodownload"
    />
  </b-modal>
</template>

<script>
export default {
  props: {
    videoSrc: {
      type: String,
      default: null,
    },
  },
  methods: {
    onModalHidden() {
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause()
        this.$refs.videoPlayer.currentTime = 0
      }
    },
  },
}
</script>cript>
